<template>
    <div class="activity-listing-related-item-align">
        <ObjectLink
            ref="objectLink"
            :tooltipContent="tooltipContent"
            :label="label"
            :link="link"
            :icon="icon"
            :size="sizeLink"
            :dataBot="`activities-listing_related-item__${data.type}-${data.id}`"
        />
        <div v-if="isPhoneNumberVisible && isMobilePhoneNumberVisible">
            <InteractiveInfo
                type="phone"
                :values="[data.phone_number, data.mobile_number]"
                variant="icons"
                :size="sizeInteractiveInfo"
            />
        </div>
        <div v-else>
            <InteractiveInfo
                v-if="isPhoneNumberVisible"
                type="phone"
                :values="[data.phone_number]"
                :size="sizeInteractiveInfo"
            />
            <InteractiveInfo
                v-if="isMobilePhoneNumberVisible"
                type="mobile"
                :values="[data.mobile_number]"
                :size="sizeInteractiveInfo"
            />
        </div>
    </div>
</template>

<script>
import { getOverviewPathFromType } from 'Config/authenticated/dictionary/overviewPath.js';
import InteractiveInfo from 'vcomponents/common/InteractiveInfo.vue';
import ObjectLink from 'vcomponents/common/object/ObjectLink.vue';
export default {
    components: {
        InteractiveInfo,
        ObjectLink,
    },
    props: {
        data: {
            type: Object,
            required: true,
        },
        isActivityPage: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            labels: {
                startCall: this.$l10n.__('Lancer un appel'),
            },
        };
    },
    computed: {
        tooltipContent() {
            if (this.isOpportunity) {
                return `${this.label} (${this.data.name})`;
            }
            return this.label;
        },
        icon() {
            switch (this.data.type) {
                case 'opportunity':
                    return 'nav-opportunity';
                case 'prospect':
                case 'supplier':
                case 'client':
                    return 'company';
                case 'people':
                    return 'nav-contact';
                default:
                    return 'nav-billing';
            }
        },
        sizeLink() {
            return this.isActivityPage ? 'medium' : 'small';
        },
        sizeInteractiveInfo() {
            return this.isActivityPage ? 'small' : 'extra-small';
        },
        link() {
            const type = ['prospect', 'supplier', 'client'].includes(this.data.type)
                ? 'client'
                : this.data.type;
            return getOverviewPathFromType({
                type,
                id: this.data.id,
                subType: this.data.type,
            });
        },
        isPhoneNumberVisible() {
            return !!this.data.phone_number;
        },
        isMobilePhoneNumberVisible() {
            return !!this.data.mobile_number;
        },
        label() {
            return this.isOpportunity ? this.data.full_name : this.data.name;
        },
        isOpportunity() {
            return this.data.type === 'opportunity';
        },
    },
};
</script>

<style lang="scss" scoped>
.activity-listing-related-item-align {
    align-items: center;
    display: flex;
    gap: var(--spacing-1);
}

.activity-listing-related-item {
    .related-item-icon__wrapper {
        background-color: var(--colors-common-background-subtle);
        border-radius: var(--spacing-0);
        padding: var(--spacing-0);
        &:has(.compass-icon--extra-small) {
            padding: 2px;
        }
    }
    &:hover {
        .related-item-icon__wrapper {
            background-color: var(--colors-common-background-primary-hover-alt);
        }
    }
}
</style>
